@for (crumb of crumbs; track $index) {
    <span [class.active]="$last">{{ crumb }}</span>
}
